import { memo, useId, useState } from "react";
import Breadcrumb from "components/shared/breadcrumb";
import { Link, useParams, useSearchParams } from "react-router-dom";
import UseFetch from "hooks/useFetch";
import { convertShamsiToUnix, faNumToEng, toMoneyFormat } from "utils";
import { CSSTransition } from "react-transition-group";
import { toast } from "react-toastify";
import MasterAPI from "service/master";
import TextareaAutosize from 'react-textarea-autosize';
import SwitchButton from "components/shared/switchButton";
import DatePickerComponent from "components/form-generator/fields/date-picker";
import SearchSelect from "components/form-generator/fields/search-select";
import Loading from "components/shared/loading";

const CurrencyRequest = () => {
    const { userId } = useParams();
    const [searhcParams] = useSearchParams();
    const formId = useId();
    const { isLoading, error, data, mutate } = UseFetch(`/api/setting/currency/request/get`);
    const [amount, setAmount] = useState("");
    const [receive, setReceive] = useState("1");
    const [fieldErros, setFieldErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);
    const [description, setDescription] = useState("");
    const [reserved, setReserved] = useState(false);
    const [reservedUntil, setReservedUntil] = useState(null);
    const [incomeTypeId, setIncomeTypeId] = useState(null);

    const amountChangeHandler = e => {
        let newVal = e.target.value;
        newVal = faNumToEng(newVal);
        newVal = newVal.replaceAll(",", "");

        if (newVal === "")
            setAmount(newVal);
        else if (/^[0-9\b]+$/.test(newVal))
            setAmount(toMoneyFormat(parseInt(newVal)));
    }

    const submitHandler = async () => {
        if (submitLoading)
            return;

        setFieldErrors({});
        setSubmitLoading(true);
        try {
            const res = await MasterAPI({
                url: "/api/setting/currency/request/edit",
                payloadType: 3,
                callback: () => setSubmitLoading(false),
                data: {
                    approve: receive === "1",
                }
            });

            toast.success(res.message);
            setAmount("");
            setReserved(false);
            setReservedUntil(null);
            setDescription("");
            setIncomeTypeId(null);
            mutate();
        } catch (e) {
            toast.error(e.message);
        }
    }

    return (
        <div className="m-container">
            <div className="flex item-start md:items-center justify-start md:justify-between flex-col md:flex-row mb-6 options-bar">
                <div className="mb-6 md:mb-0">
                    <h1 className="title-c1 tp-21">تایید نرخ ارز</h1>
                    <Breadcrumb data={[
                        { title: "تایید نرخ ارز" }
                    ]} />
                </div>

                <div className="flex">
                    <Link to={"/panel/wallet"} className="w-10 h-10 tp-22 text-[#424e79] dark:text-white ml-3 rounded-md fit-center">
                        <i className="fa-regular fa-arrow-right"></i>
                    </Link>

                    <button className="w-10 h-10 tp-22 text-[#424e79] dark:text-white rounded-md fit-center ml-3" onClick={mutate} title="بروز رسانی">
                        <i className="fa-regular fa-arrows-retweet"></i>
                    </button>

                    <button
                        className={`bg-primary-100 hover:bg-primary-200 px-7 transition-colors text-white rounded-md fit-center text-sm h-10 relative overflow-hidden${submitLoading ? " cursor-progress" : ""}`}
                        onClick={submitHandler}
                    >
                        ثبت

                        <CSSTransition in={submitLoading} timeout={200} unmountOnExit={true}>
                            <span className="pos-cover bg-primary-200 fit-center anim-c4">
                                <i className="fa-solid fa-spinner spin"></i>
                            </span>
                        </CSSTransition>
                    </button>
                </div>
            </div>

            <div className="wrap-box tp-22 page-transition">
                {
                    !isLoading ? (
                        !error ? (
                            <>
                                <div className="tp-9 text-sm">
                                    <span>نرخ قبلی ارز:</span>
                                    <b className="mr-2">{toMoneyFormat(data.data.old_rate)}</b>
                                    <span className="text-xs"> تومان</span>
                                </div>
                                <div className="tp-9 text-sm">
                                    <span>نرخ جدید ارز:</span>
                                    <b className="mr-2">{toMoneyFormat(data.data.new_rate)}</b>
                                    <span className="text-xs"> تومان</span>
                                </div>
                            </>
                        ) : <p className="">تغییری برای تایید یا رد وجود ندارد</p>
                    ) : (
                        <div className="fit-center">
                            <Loading className="loading-c5" />
                        </div>
                    )
                }

                <div className="mt-10">
                    <div className="grid grid-cols-1 gap-5">
                        <label className="select-c1">
                            <span>نرخ</span>

                            <select id={`${formId}_recive`} value={receive} onChange={e => setReceive(e.target.value)}>
                                <option value="1">تایید</option>
                                <option value="0">رد</option>
                            </select>
                        </label>

                    </div>
                </div>
            </div>
        </div >
    )
}

export default memo(CurrencyRequest);